import type { StoreProduct, StoreProductVariant } from "@medusajs/types"
import { captureAnalyticsEvent } from "@/lib/analytics/posthog-client"
import { track } from "@vercel/analytics"

export type AddToCartEventPayload = {
  lineItems: {
    productVariant: StoreProductVariant & {
      product: StoreProduct
    }
    quantity: number
  }[]
  regionId: string
}

type CartAddEventHandler = (payload: AddToCartEventPayload) => void

type CartAddEventBus = {
  emitCartAdd: (payload: AddToCartEventPayload) => void
  handler: CartAddEventHandler
  registerCartAddHandler: (handler: CartAddEventHandler) => void
}

export const addToCartEventBus: CartAddEventBus = {
  emitCartAdd(payload: AddToCartEventPayload) {
    this.handler(payload)

    for (const lineItem of payload.lineItems) {
      // Track with Vercel Analytics
      track("add_to_cart", {
        product_name: lineItem.productVariant.title,
        quantity: lineItem.quantity,
      })

      captureAnalyticsEvent("cart_item_added", {
        product_id: lineItem.productVariant.product.id,
        product_title: lineItem.productVariant.product.title,
        variant_id: lineItem.productVariant.id,
        variant_title: lineItem.productVariant.title,
        quantity: lineItem.quantity,
        region_id: payload.regionId,
      })
    }
  },

  handler: () => {},

  registerCartAddHandler(handler: CartAddEventHandler) {
    this.handler = handler
  },
}

/** Event dispatched when the cart drawer closes; express checkout listens to refresh its cart state. */
export const CART_DRAWER_CLOSED = "cart-drawer-closed"

export function dispatchCartDrawerClosed() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CART_DRAWER_CLOSED))
  }
}
